<div class="increment-number-input input" [ngClass]="{'disabled': isDisabled}">
  <button type="button" (click)="decrement()" [disabled]="isDisabled">-</button>
  <input appNumbersOnly [(ngModel)]="number" (input)="onInput($event)"  [disabled]="isDisabled"/>
  <button type="button" (click)="increment()" [disabled]="isDisabled">+</button>
</div>
